// ClosureLetterService.jsx
import React, { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { Button, Icon } from 'semantic-ui-react';
import ClosureLetter from '../PdfLetters/ClosureLetter';
import { useReactToPrint } from 'react-to-print';
import { setPage } from '../../redux/appSlice';
import { setLetter } from "../../redux/projectSlice";

const useTitle = (title) => {
    useEffect(() => {
        const prevTitle = document.title;
        document.title = title;
        return () => {
            document.title = prevTitle;
        };
    }, [title]);
};

const ClosureLetterService = () => {
    const projectState = useSelector(state => state.project);
    const dispatch = useDispatch();
    const API_MDB = process.env.REACT_APP_BASE_API_URL_MDB;
    const options = {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    };

    // Ref attaché à un div englobant tout le contenu à imprimer
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    const updateLetterDataAndPrint = async () => {
        const resLetter = await axios.patch(
            `${API_MDB}/letters/${projectState.letter._id}`,
            projectState.letter,
            options
        );
        if (resLetter.status === 204) {
            handlePrint();
        }
    };

    const getLetterData = async () => {
        if (!projectState.letter.projectNumber) {
            const resLetter = await axios.get(
                `${API_MDB}/letters/${projectState.project.customIdentifier}`,
                options
            );
            if (resLetter.status === 200) {
                dispatch(setLetter(resLetter.data));
            } else {
                console.error('Error fetching letter data');
            }
        }
    };

    useTitle(`${projectState.project.customIdentifier} ${projectState.project.acronym}_ClosureLetter`);
    getLetterData();
    return (
        <div>
            <div className="menu">
                <Button.Group>
                    <Button
                        icon
                        onClick={() => dispatch(setPage('Projects'))}
                        color="blue"
                        labelPosition="left"
                    >
                        <Icon name="arrow left" />
                        Back
                    </Button>
                    <Button.Or />
                    <Button
                        icon
                        onClick={updateLetterDataAndPrint}
                        color="blue"
                        labelPosition="right"
                    >
                        <Icon name="print" />
                        Print
                    </Button>
                </Button.Group>
            </div>

            {/* Ref attaché ici à un div englobant tout le contenu à imprimer */}
            <div ref={componentRef}>
                <ClosureLetter projectState={projectState} />
            </div>
        </div>
    );
};

export default ClosureLetterService;
